<template>
  <section class="ribbon">
    <slot />
  </section>
</template>
